// Public Road Ready Network site (founding-partners-site). The Founding Partner
// apply/pay/claim/directory flow lives there now — the old copies on this site
// redirect to it. Swap the fallback once roadreadynetwork.com is attached.
export const ROAD_READY_SITE_URL =
  process.env.REACT_APP_ROAD_READY_SITE_URL ||
  'https://founding-partners-site-e2eef48b112d.herokuapp.com';
